import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enCommon from '../locales/en/common.json';
import enSidebar from '../locales/en/sidebar.json';
import enDashboard from '../locales/en/dashboard.json';
import enHome from '../locales/en/home.json';
import enRewards from '../locales/en/rewards.json';
import enProfile from '../locales/en/profile.json';
import enSubscription from '../locales/en/subscription.json';
import enMeetings from '../locales/en/meetings.json';
import enSettings from '../locales/en/settings.json';
import enMeetingTopBar from '../locales/en/meetingTopBar.json';
import enStartMeeting from '../locales/en/startMeeting.json';
import enUserManagement from '../locales/en/userManagement.json';
import enShareEnterprise from '../locales/en/shareEnterprise.json';
import enPayments from '../locales/en/payments.json';
import enRecordings from '../locales/en/recordings.json';
import enLinks from '../locales/en/links.json';
import enPresentations from '../locales/en/presentations.json';
import enCohosts from '../locales/en/cohosts.json';
import enAssistant from '../locales/en/assistant.json';
import enAiTools from '../locales/en/aiTools.json';
import enMeetingReports from '../locales/en/meetingReports.json';
import enMyCredits from '../locales/en/myCredits.json';
import enCommunicationCentral from '../locales/en/communicationCentral.json';
import enSmartLinks from '../locales/en/smartLinks.json';
import enNotifications from '../locales/en/notifications.json';
import enFamilyPlan from '../locales/en/familyPlan.json';

import esCommon from '../locales/es/common.json';
import esSidebar from '../locales/es/sidebar.json';
import esDashboard from '../locales/es/dashboard.json';
import esHome from '../locales/es/home.json';
import esRewards from '../locales/es/rewards.json';
import esProfile from '../locales/es/profile.json';
import esSubscription from '../locales/es/subscription.json';
import esMeetings from '../locales/es/meetings.json';
import esSettings from '../locales/es/settings.json';
import esMeetingTopBar from '../locales/es/meetingTopBar.json';
import esStartMeeting from '../locales/es/startMeeting.json';
import esUserManagement from '../locales/es/userManagement.json';
import esShareEnterprise from '../locales/es/shareEnterprise.json';
import esPayments from '../locales/es/payments.json';
import esRecordings from '../locales/es/recordings.json';
import esLinks from '../locales/es/links.json';
import esPresentations from '../locales/es/presentations.json';
import esCohosts from '../locales/es/cohosts.json';
import esAssistant from '../locales/es/assistant.json';
import esAiTools from '../locales/es/aiTools.json';
import esMeetingReports from '../locales/es/meetingReports.json';
import esMyCredits from '../locales/es/myCredits.json';
import esCommunicationCentral from '../locales/es/communicationCentral.json';
import esSmartLinks from '../locales/es/smartLinks.json';
import esNotifications from '../locales/es/notifications.json';
import esFamilyPlan from '../locales/es/familyPlan.json';

import filCommon from '../locales/fil/common.json';
import filSidebar from '../locales/fil/sidebar.json';
import filDashboard from '../locales/fil/dashboard.json';
import filHome from '../locales/fil/home.json';
import filRewards from '../locales/fil/rewards.json';
import filProfile from '../locales/fil/profile.json';
import filSubscription from '../locales/fil/subscription.json';
import filMeetings from '../locales/fil/meetings.json';
import filSettings from '../locales/fil/settings.json';
import filMeetingTopBar from '../locales/fil/meetingTopBar.json';
import filStartMeeting from '../locales/fil/startMeeting.json';
import filUserManagement from '../locales/fil/userManagement.json';
import filShareEnterprise from '../locales/fil/shareEnterprise.json';
import filPayments from '../locales/fil/payments.json';
import filRecordings from '../locales/fil/recordings.json';
import filLinks from '../locales/fil/links.json';
import filPresentations from '../locales/fil/presentations.json';
import filCohosts from '../locales/fil/cohosts.json';
import filAssistant from '../locales/fil/assistant.json';
import filAiTools from '../locales/fil/aiTools.json';
import filMeetingReports from '../locales/fil/meetingReports.json';
import filMyCredits from '../locales/fil/myCredits.json';
import filCommunicationCentral from '../locales/fil/communicationCentral.json';
import filSmartLinks from '../locales/fil/smartLinks.json';
import filNotifications from '../locales/fil/notifications.json';
import filFamilyPlan from '../locales/fil/familyPlan.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: false,
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },

    interpolation: {
      escapeValue: false,
    },

    resources: {
      en: {
        common: enCommon,
        sidebar: enSidebar,
        dashboard: enDashboard,
        home: enHome,
        rewards: enRewards,
        profile: enProfile,
        subscription: enSubscription,
        meetings: enMeetings,
        settings: enSettings,
        meetingTopBar: enMeetingTopBar,
        startMeeting: enStartMeeting,
        userManagement: enUserManagement,
        shareEnterprise: enShareEnterprise,
        payments: enPayments,
        recordings: enRecordings,
        links: enLinks,
        presentations: enPresentations,
        cohosts: enCohosts,
        assistant: enAssistant,
        aiTools: enAiTools,
        meetingReports: enMeetingReports,
        myCredits: enMyCredits,
        communicationCentral: enCommunicationCentral,
        smartLinks: enSmartLinks,
        notifications: enNotifications,
        familyPlan: enFamilyPlan
      },
      es: {
        common: esCommon,
        sidebar: esSidebar,
        dashboard: esDashboard,
        home: esHome,
        rewards: esRewards,
        profile: esProfile,
        subscription: esSubscription,
        meetings: esMeetings,
        settings: esSettings,
        meetingTopBar: esMeetingTopBar,
        startMeeting: esStartMeeting,
        userManagement: esUserManagement,
        shareEnterprise: esShareEnterprise,
        payments: esPayments,
        recordings: esRecordings,
        links: esLinks,
        presentations: esPresentations,
        cohosts: esCohosts,
        assistant: esAssistant,
        aiTools: esAiTools,
        meetingReports: esMeetingReports,
        myCredits: esMyCredits,
        communicationCentral: esCommunicationCentral,
        smartLinks: esSmartLinks,
        notifications: esNotifications,
        familyPlan: esFamilyPlan
      },
      fil: {
        common: filCommon,
        sidebar: filSidebar,
        dashboard: filDashboard,
        home: filHome,
        rewards: filRewards,
        profile: filProfile,
        subscription: filSubscription,
        meetings: filMeetings,
        settings: filSettings,
        meetingTopBar: filMeetingTopBar,
        startMeeting: filStartMeeting,
        userManagement: filUserManagement,
        shareEnterprise: filShareEnterprise,
        payments: filPayments,
        recordings: filRecordings,
        links: filLinks,
        presentations: filPresentations,
        cohosts: filCohosts,
        assistant: filAssistant,
        aiTools: filAiTools,
        meetingReports: filMeetingReports,
        myCredits: filMyCredits,
        communicationCentral: filCommunicationCentral,
        smartLinks: filSmartLinks,
        notifications: filNotifications,
        familyPlan: filFamilyPlan
      },
    },
  });

export default i18n;
